module.exports = __webpack_public_path__ + "static/media/petPursuitLogo.95b4fd51.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/petPursuitLogo.png
// module id = 175
// module chunks = 0